export default "__VITE_ASSET__DRPXtQFQ__"